export interface Voucher {
  amount: number;
  description: string;
  expirationDate: string;
  memberNumber: string;
  productName: VoucherProductName;
  qty: string;
  status: VoucherStatus;
  transactionId: string;
  type: VoucherType;
  voucherCode: VoucherCode;
  voucherExpiredDate: string;
  voucherExpiredMonth: string;
  voucherExpiredYear: string;
  voucherIssuedDate: string;
  voucherIssuedMonth: string;
  voucherIssuedYear: string;
  voucherNumber: string;
  voucherNumbers: string[];
}

export enum VoucherType {
  LONG_HAUL = 'Long Haul',
}

export enum VoucherProductName {
  LONG_HAUL_UPGRADE = 'Long Haul Upgrade',
  UPGRADE_BENEFIT = 'Upgrade Benefit',
  EUROPE_UPGRADE = 'Europe Upgrade',
  GOLD_CARD_GIFT = 'Gold Card Gift',
  AY_LOUNGE_PASS = 'AY Lounge Pass',
  MILESTONE_200K = 'Milestone 200K',
}

export enum VoucherStatus {
  AVAILABLE = 'Available',
}

export enum VoucherCode {
  ELECTRONIC_VOUCHER = 'Electronic Voucher',
}

export interface VouchersResponse {
  vouchers: {
    partStatus: {
      code: string;
      versionTimestamp: string;
    };
    vouchers: Voucher[];
  };
}
